import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_ListMediaAnalysisJobsCommand, se_ListMediaAnalysisJobsCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class ListMediaAnalysisJobsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "ListMediaAnalysisJobs", {})
    .n("RekognitionClient", "ListMediaAnalysisJobsCommand")
    .f(void 0, void 0)
    .ser(se_ListMediaAnalysisJobsCommand)
    .de(de_ListMediaAnalysisJobsCommand)
    .build() {
}
